import{Cell as t}from"@react-stately/table";const e=t;export default e;